import styled from "styled-components";

export const Wrapper = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  svg {
    path {
      stroke: ${({ theme }) => theme.message.color};
    }
  }
`;
export const Text = styled.span``;
export const Container = styled.div`
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: ${({ theme }) => theme.message.color};
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.message.color};
  text-decoration: underline;
  margin: 0 5px;
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  line-height: 24px;

  &:hover {
    text-decoration: none;
  }
`;

export const ButtonWrapper = styled.div`
  max-width: 200px;
  margin-top: 8px;

  span {
    font-weight: 400;
  }

  ${({ $isShopifyApp, theme }) =>
    $isShopifyApp &&
    `
    button {
      border: 1px solid ${theme.pallette.red.background};
    }

    span {
      font-weight: 500;
      color: ${theme.buttons.secondary.color}!important;
    }

    svg path {
      stroke: ${theme.buttons.secondary.color}!important;
    }

    button:not(:disabled):hover,
    button:not(:disabled):focus {
      border: 1px solid ${theme.pallette.red.background}!important;
    }
  `}
`;
